module.exports = __webpack_public_path__ + "img/quest_selector_highlight.76413150.png";